exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../../../css-loader/dist/cjs.js??ref--8-1!../../styles/custom-properties.css"), "");
exports.i(require("-!../../../../../css-loader/dist/cjs.js??ref--8-1!../../styles/colors.css"), "");
// Module
exports.push([module.id, ".wyLaYkw-T9LA4KGj2H2az{width:100%;display:table;height:8px}html[dir] .wyLaYkw-T9LA4KGj2H2az{border-radius:var(--preview-border-radius) var(--preview-border-radius) 0 0}", ""]);
// Exports
exports.locals = {
	"n-colorStripe": "wyLaYkw-T9LA4KGj2H2az"
};